// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Component Imports
// JS Imports
// Asset Imports

// Component Imports
import Description from '../../ui-helper-elements/Description'

export default function TotalsHeaderRow() {
   const state = useQuoteContext()
   const { getString } = state
   const permissions = state.featurePermissions['ResellerTotal']
   const permissionsAdmin = state.featurePermissions['AdminPermission']

   return (
      <div className='row'>
         {state.productCoreEECount > 0 ||
         state.productTimeTrackingEECount > 0 ||
         state.productAdditionalJobsCount > 0 ||
         state.productPerformanceEECount > 0 ||
         state.productBenefitsAdministrationEECount > 0 ||
         state.productPayrollTotalEECount > 0 ||
         state.productPayrollTotalStateCount > 0 ? (
            <Description
               className='col-bhr1 col-bhr5'
               title='Commission MRR'
               content={
                  <>
                     {/* CoreProduct */}
                     {(state?.productCoreEECount || 0) > 0 ? (
                        <div className='row'>
                           <div className='col'>
                              {state?.product_list?.[
                                 state?.coreProductSelected || ''
                              ]?.['ProductName'] || getString('global.HRIS')}
                           </div>
                           <div className='col col-bhr-red text-end'>
                              {formatFloatAsCurrencySymbol(
                                 state?.productCoreMonthlyCosts?.MRRTotal || 0,
                                 state?.currencyObject || {},
                              )}
                           </div>
                        </div>
                     ) : (
                        <></>
                     )}

                     {/* PerformanceProduct */}
                     {state.productPerformanceEECount > 0 &&
                     'performanceMan' in state.product_list ? (
                        <div className='row'>
                           <div className='col text-nowrap'>
                              {'performanceMan' in state.product_list
                                 ? state.product_list['performanceMan'][
                                      'ProductName'
                                   ]
                                 : ''}{' '}
                              (
                              {'performanceMan' in state.product_list
                                 ? formatFloatAsCurrencySymbol(
                                      state.product_list['performanceMan'][
                                         'EmpListPrice'
                                      ],
                                      state.currencyObject,
                                   )
                                 : ''}
                              )
                           </div>
                           <div className='col col-bhr-red text-end'>
                              {formatFloatAsCurrencySymbol(
                                 state.productPerformanceMonthlyCosts.MRRTotal,
                                 state.currencyObject,
                              )}
                           </div>
                        </div>
                     ) : (
                        <></>
                     )}

                     {/* TimeTrackingProduct */}
                     {state.productTimeTrackingEECount > 0 ? (
                        <div className='row'>
                           <div className='col text-nowrap'>
                              {
                                 state.product_list['timeTracking'][
                                    'ProductName'
                                 ]
                              }{' '}
                              (
                              {formatFloatAsCurrencySymbol(
                                 state.product_list['timeTracking'][
                                    'EmpListPrice'
                                 ],
                                 state.currencyObject,
                              )}
                              )
                           </div>
                           <div className='col col-bhr-red text-end'>
                              {formatFloatAsCurrencySymbol(
                                 state.productTimeTrackingMonthlyCosts.MRRTotal,
                                 state.currencyObject,
                              )}
                           </div>
                        </div>
                     ) : (
                        <></>
                     )}

                     {/* AdditionalJobPosting */}
                     {state.productAdditionalJobsCount > 0 ? (
                        <div className='row'>
                           <div className='col text-nowrap'>
                              {getString(
                                 'product.TotalsHeaderRow.AdditionalJobPosting.Text',
                              )}
                           </div>
                           <div className='col col-bhr-red text-end'>
                              {formatFloatAsCurrencySymbol(
                                 state.AdditionalJobsCosts.MRRTotal,
                                 state.currencyObject,
                              )}
                           </div>
                        </div>
                     ) : (
                        <></>
                     )}

                     {/* BenefitsAdministrationProduct */}
                     {state.productBenefitsAdministrationEECount > 0 ? (
                        <div className='row'>
                           <div className='col text-nowrap'>
                              {state.product_list['benAdmin']['ProductName']} (
                              {formatFloatAsCurrencySymbol(
                                 state.product_list['benAdmin']['EmpListPrice'],
                                 state.currencyObject,
                              )}
                              )
                           </div>
                           <div className='col col-bhr-red text-end'>
                              {formatFloatAsCurrencySymbol(
                                 state.productBenefitsAdministrationMonthlyCosts
                                    .MRRTotal,
                                 state.currencyObject,
                              )}
                           </div>
                        </div>
                     ) : (
                        <></>
                     )}

                     {/* PayrollProduct */}
                     {state.productPayrollTotalEECount > 0 ? (
                        <div className='row'>
                           <div className='col text-nowrap'>
                              {getString(
                                 'product.TotalsHeaderRow.Payroll.Text',
                              )}
                           </div>
                           <div className='col col-bhr-red text-end'>
                              {formatFloatAsCurrencySymbol(
                                 state.payrollMonthlyTotal.MRRTotal,
                                 state.currencyObject,
                              )}
                           </div>
                        </div>
                     ) : (
                        <></>
                     )}

                     {/*Total of MRR */}
                     <div className='row'>
                        <div className='col text-nowrap'>
                           <b>{getString('global.Total')}</b>
                        </div>
                        <div className='col col-bhr-red text-end'>
                           {formatFloatAsCurrencySymbol(
                              state.monthlyTotal.MRRTotal,
                              state.currencyObject,
                           )}
                        </div>
                     </div>
                  </>
               }
            >
               <span className='hoverable'>
                  <h5 className='col'>
                     {permissions.includes(state.user_role) ||
                     (permissionsAdmin.includes(state.user_role) &&
                        state.discountReseller > 0)
                        ? getString(
                             'product.TotalsHeaderRow.Payroll.HoverableResellerText',
                          )
                        : getString(
                             'product.TotalsHeaderRow.Payroll.HoverableText',
                          )}
                  </h5>
               </span>
            </Description>
         ) : (
            <h5 className='col-bhr1 col-bhr5'>
               {permissions.includes(state.user_role) ||
               (permissionsAdmin.includes(state.user_role) &&
                  state.discountReseller > 0)
                  ? getString(
                       'product.TotalsHeaderRow.Payroll.HoverableResellerText',
                    )
                  : getString('product.TotalsHeaderRow.Payroll.HoverableText')}
            </h5>
         )}
         <h5 className='col'>{getString('global.PEPM')}</h5>
         <h5 className='col'>
            {!(
               permissions.includes(state.user_role) ||
               (permissionsAdmin.includes(state.user_role) &&
                  state.discountReseller > 0)
            ) && <span>%</span>}
         </h5>
         <h5 className='col'>{getString('global.Total')}</h5>
      </div>
   )
}
